<template>
  <div class="common">
    <div class="commonCenter">
      <div
        class="div1"
        data-wow-duration="1s"
        data-wow-delay=".5"
        v-for="(item, index) in showPage"
        :key="item.id"
        :class="{ active: index === curId }"
        @click="tab(index)"
      >
        <p class="dp1">
          {{ item.title }}
        </p>
        <p class="dp2 wow animated bounceInRight">
          {{ item.brief }}
        </p>
        <p class="dp3" v-html="TwoDetails.content" v-show="index === curId"></p>
      </div>
    </div>
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        :total="num"
        :page-size="Onepage"
        background
        prev-text="<"
        next-text=">"
        @current-change="handleCurrentChange"
        pager-count=5
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { GetColumn_List, GetDetails } from "@/https/http";
export default {
  data() {
    return {
      List: "",
      flag: false,
      curId: 0,
      gengduoShow: true,
      TwoDetails: "",
      Onepage: 5,
      num: null,
      cur: 1,
      showPage: "",
      totalPage: "",
    };
  },
  created() {
    this.FanYe();
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
  },
  methods: {
    tab(index) {
      this.curId = index;
      GetDetails({ id: this.showPage[index].id, modular: "5" }).then((res) => {
        this.TwoDetails = res.result;
      });
    },
    Page(num) {
      console.log(num,'当前页')
      this.cur = num; //当前页
      // var list = (this.cur - 1) * this.Onepage; //每去一组数据的第一个索引
      // this.showPage = this.List.slice(list, list + this.Onepage); //从总数据中取出每页的数据
      console.log(this.showPage)
      GetDetails({ id: this.showPage[0].id, modular: "5" }).then((res) => {
        this.TwoDetails = res.result;
      });
    },
    handleCurrentChange(cpage) {
      window.scrollTo({
        top: 500,
        behavior: "smooth",
      });
      this.cur = cpage;
      this.curId = 0;
      this.FanYe()
      this.Page(this.cur);

    },
    FanYe() {
      GetColumn_List({
        number:'5',
        page:this.cur,
        modular: 5 
        }).then((res) => {
        console.log(res)
        this.showPage = res.result.data;
        this.num = parseInt(res.result.totalRecords);
        this.totalPage = Math.ceil(res.result.length / this.Onepage);
        // this.Page(this.cur);
      });
    },
  },
};
</script>
<style lang="scss" >
@media screen and(min-width:1020px){
  .div1.active {
  width: 1440px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px #ffd9be;
  margin: 0 auto;
  border-top: 4px solid #ff8229;
}
.common {
  width: 100%;
  min-width: 1440px;
  .commonCenter {
    width: 1440px;
    margin: 0 auto;
    overflow: hidden;
    .div1 {
      margin-top: 79px;
      padding-left: 74px;
      width: 1440px;
      border-bottom: 1px solid #e6e6e6;
      .dp1:hover {
        color: #ff8229;
      }
      .dp1 {
        margin-bottom: 32px;
        height: 28px;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 25px;
        cursor: pointer;
      }
      .dp2 {
        width: 1232px;
        height: 77px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
      }
      .dp3 {
        width: 1248px;
        padding-bottom: 30px;
      }
    }
  }
  .block {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    .el-pagination {
      height: 30px;
      display: flex;
      align-items: center;
      margin-top: 30px;
      margin-bottom: 30px;
      justify-content: center;
      .btn-prev,
      .btn-next {
        width: 40px;
        height: 35px;
      }
      .btn-next {
        margin-left: 30px;
      }
      .el-pager {
        display: flex;
        list-style: none;
        .number {
          width: 20px;
          height: 20px;
          margin-left: 30px;
          text-align: center;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        li {
          list-style: none;
        }
        .number.active {
          width: 20px;
          height: 20px;
          background: #ff8229;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
}
@media screen and(max-width:1020px){
  .common{
    width: 100%;
    .commonCenter{
      width: 100%;
      .div1.active {
        width: 100%;
        background: #ffffff;
        box-shadow: 0px 0px 20px 0px #ffd9be;
        margin: 0 auto;
        border-top: 4px solid #ff8229;
      }
      .div1{
        width: 100%;
        box-sizing: border-box;
        padding-left:15px;
        padding-right:15px;
        .dp1:hover {
          color: #ff8229;
        }
      .dp1 {
        margin:0;
        margin-top:15px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 25px;
        cursor: pointer;
      }
      .dp2 {
        margin:0;
        margin-top:15px;
        width: 100%;
        height: 77px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
      }
      .dp3 {
        width: 100%;
        padding-bottom: 30px;
      }
      }
    }
  }
  .block{
    margin-top:20px;
    width:100%;
    // margin:0 auto;
    display:flex;
    justify-content: center;
  }
}

</style>